import EventEmitter from "./utils/EventEmitter";
import FontFaceObserver from 'fontfaceobserver'

export default class ListInterventionsMediatiquesPage extends EventEmitter {
    constructor(element) {
        super();

        this.el = element;

        this.flux = document.querySelector('.interventions-mediatiques.view-content');
        this.newsletterBloc = document.querySelector('.newsletter-content-wrapper');

        const font = new FontFaceObserver('Sora')

        font.load().then(() => {
            if (this.newsletterBloc && this.flux) {
                // this.supportBlockClone = this.supportBlock.cloneNode(true);
                // this.supportBlock.remove();
                this.insertNewsletterBlock().then(() => {
                    this.newsletterBloc.remove()
                })
            }
        })
    }

    insertNewsletterBlock() {
        return new Promise((resolve) => {
            const viewContent = this.flux

            const viewContentChildren = Array.from(viewContent.children)
            const middleIndex = Math.floor(viewContentChildren.length / 2)
            const middleChild = viewContentChildren[middleIndex]
            middleChild.previousElementSibling.classList.remove('u-dashed-bottom')
            const newsletterBlockClone = this.newsletterBloc.cloneNode(true);
            viewContent.insertBefore(newsletterBlockClone, middleChild)

            setTimeout(() => {
                resolve()
            },250)
        })
    }

}
